import { NgModule, inject } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoginGuard } from './login/login.guard';
import { AutoLoginGuard } from './login/autologin.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule),
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AutoLoginGuard).canActivate(route, state)],
    canMatch: [() => inject(AutoLoginGuard).canLoad()]
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule),
    canActivate: [() => inject(LoginGuard).canActivate()],
    canMatch: [() => inject(LoginGuard).canLoad()]
  },
  {
    path: 'course/:id',
    loadChildren: () => import('./course/course.module').then(m => m.CoursePageModule),
    canActivate: [() => inject(LoginGuard).canActivate()],
    canMatch: [() => inject(LoginGuard).canLoad()]
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
